import { motion } from "framer-motion";

const EXPERIENCES = [
    {
        role: "Full Stack Developer",
        company: "ZuCite Technologies",
        duration: "Oct 2024 - Present",
        points: [
            "Optimized the portal's performance using Next.js SSR, CSR, ISR, and SEO metadata.",
            "Worked on advanced session manipulation using JWT and middleware.",
            "Integrated AI automation workflows and conversational AI Assistants."
        ]
    },
    {
        role: "Software Developer Intern",
        company: "ZuCite Technologies",
        duration: "June 2024 - Sep 2024",
        points: [
            "Assisted in the development of responsive layouts using Next.js.",
            "Built reusable, modular UI components.",
            "Gained hands-on experience in Next.js & MongoDB."
        ]
    },
    {
        role: "Apprentice Trainee",
        company: "TP Vision",
        duration: "Feb 2024 - June 2024",
        points: [
            "Integrated multi-language capabilities into the web portal, improving accessibility for global users.",
            "Implemented a scalable data-loading strategy for remote device lists, enabling faster navigation.",
            "Gained hands-on experience in React, Fastify, GraphQL, and Python."
        ]
    }
];

export const Experience = () => {
    return (
        <section id="work" className="py-24 overflow-x-hidden">
            <motion.h2
                className="text-4xl font-bold text-white text-center mb-16"
                initial={{ opacity: 0, y: -20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
            >
                Experience
            </motion.h2>

            <div className="relative max-w-4xl mx-auto px-6">
                <div
                    aria-hidden="true"
                    className="absolute left-6 md:left-1/2 transform md:-translate-x-1/2 top-0 bottom-0 w-[2px] bg-gradient-to-b from-blue-500 via-purple-500 to-transparent rounded-full"
                />

                <div className="space-y-12 md:space-y-16">
                    {EXPERIENCES.map((exp, index) => {
                        const isEven = index % 2 === 0;

                        return (
                            <motion.div
                                key={exp.role + exp.company}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-60px" }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                                className={`relative flex items-center ${isEven ? "md:justify-start" : "md:justify-end"
                                    } pl-8 md:pl-0`}
                            >
                                <div
                                    aria-hidden="true"
                                    className="absolute left-[-2px] md:left-1/2 transform md:-translate-x-1/2 w-4 h-4 rounded-full bg-blue-500 ring-4 ring-[#0f172a] shadow-[0_0_12px_rgba(59,130,246,0.5)] z-10"
                                />

                                <div className="bg-[#0f172a]/90 border border-slate-700/70 p-6 rounded-2xl shadow-xl w-full md:w-[46%] transition-transform hover:-translate-y-1 duration-200">
                                    <h3 className="text-xl font-semibold text-white">{exp.role}</h3>
                                    <h4 className="text-base font-medium text-blue-400 mt-0.5">{exp.company}</h4>

                                    <p className="mt-2 text-slate-400 text-xs font-medium uppercase tracking-wide">
                                        {exp.duration}
                                    </p>

                                    <ul className="mt-4 space-y-2 text-slate-300 text-sm list-disc list-outside ml-4">
                                        {exp.points.map((point, i) => (
                                            <li key={i} className="leading-relaxed">
                                                {point}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};